module.exports = __webpack_public_path__ + "img/diamond_level2.a5264429.png";